module.exports = __webpack_public_path__ + "d044ce78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/service-wheel.svg
// module id = 3086
// module chunks = 17